"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIGrid(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className"]);
  return _react.default.createElement("div", Object.assign({}, props, {
    className: (0, _classnames.default)('row', className)
  }), children);
}

UIGrid.propTypes = {
  children: _propTypes.default.node.isRequired
};
UIGrid.displayName = 'UIGrid';
var _default = UIGrid;
exports.default = _default;
module.exports = exports.default;